// extracted by mini-css-extract-plugin
module.exports = {"description":"reviewPermissionsModal_description__1soY_","actionBtn":"reviewPermissionsModal_actionBtn__HMJDg","table":"reviewPermissionsModal_table__Mr10B"};